import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import AdminGalleryUpload from "../GalleryUpload";
import * as S from "./styles";

// Moderação do ÁLBUM (ex-"Galeria" — A10/D7/D25 de 29/08/2026, ampliado pelos
// D16–D18 da parte 2 em 03/09/2026): o admin vê TODOS os itens (o backend só
// entrega os não-aprovados para ele) e aprova/reprova os pendentes. Proponente
// e patrocinador só enxergam os Aprovados.
//
// O Álbum deixou de ser só imagem: item de vídeo/áudio/arquivo/link não pode
// ser renderizado com <img> (viria quebrado), então cada tipo tem sua caixa.
const UpdateProjectGallery = ({ projectId, onModerated }) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const [images, setImages] = useState([]);

  const getGallery = () => {
    api
      .post("/projects/gallery", { project_id: projectId })
      .then((response) => setImages(response.data || []))
      .catch((error) => HTTPErrorCallback(error));
  };

  useEffect(() => {
    if (projectId) getGallery();
    // eslint-disable-next-line
  }, [projectId]);

  const evaluateImage = async (file_id, approved) => {
    setLoading(true);

    try {
      await api.post("/projects/gallery/evaluate", { file_id, approved });

      setLoading(false);
      showNotification("success", "Sucesso!", "Imagem avaliada com sucesso!");
      getGallery();
      // Avaliou: o badge da aba precisa cair na hora (05/09/2026).
      if (onModerated) onModerated();
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      {/* A equipe também publica no Álbum (05/09/2026): antes esta sessão só
          moderava o que o proponente mandava. Item do admin nasce Aprovada. */}
      <AdminGalleryUpload projectId={projectId} reload={getGallery} />

      {!images.length ? <span>Nenhum item no Álbum.</span> : null}

      <S.Grid>
        {images.map((image) => (
          <S.Card key={image.id}>
            {(image.type || "image") === "image" ? (
              <img src={image.file_src} alt={image.name} />
            ) : (
              <S.NonImage
                href={image.file_src}
                target="_blank"
                rel="noreferrer"
              >
                {image.type === "video"
                  ? "Vídeo"
                  : image.type === "audio"
                    ? "Áudio"
                    : image.type === "link"
                      ? "Link externo"
                      : "Arquivo"}
              </S.NonImage>
            )}
            <span>{image.name}</span>
            <S.Status status={image.approval_status}>
              {image.approval_status}
            </S.Status>

            {image.approval_status === "Pendente" ? (
              <S.Buttons>
                <Button
                  variant="critical"
                  type="button"
                  text="Reprovar"
                  onClick={() => evaluateImage(image.id, false)}
                  disabled={loading}
                />
                <Button
                  variant="success"
                  type="button"
                  text="Aprovar"
                  onClick={() => evaluateImage(image.id, true)}
                  disabled={loading}
                />
              </S.Buttons>
            ) : null}
          </S.Card>
        ))}
      </S.Grid>
    </S.Wrapper>
  );
};

export default UpdateProjectGallery;
